export default "__VITE_ASSET__DcqBt5fF__"